import React from 'react';
import {Button, Col, FormControl, FormGroup, Panel, Row} from 'react-bootstrap';
import DateTime from 'react-datetime';

const RedemptionSearch = props => (
  <Panel className="order-filter">
    <Row>
      <Col md={6}>
        <FormGroup>
          <FormControl
            onChange={props.onInputChange}
            placeholder="customer number, email, mobile, user id, first name, last name"
            value={props.searchValue}
          />
        </FormGroup>
      </Col>
      <Col md={3}>
        <FormGroup>
          <DateTime
            closeOnSelect
            dateFormat="DD/MM/YYYY"
            inputProps={{
              placeholder: 'Redemption date from'
            }}
            onChange={props.onDateFromChange}
            timeFormat={false}
            value={props.dateFromValue}
          />
        </FormGroup>
      </Col>
      <Col md={3}>
        <FormGroup>
          <DateTime
            closeOnSelect
            dateFormat="DD/MM/YYYY"
            inputProps={{
              placeholder: 'Redemption date to'
            }}
            onChange={props.onDateToChange}
            timeFormat={false}
            value={props.dateToValue}
          />
        </FormGroup>
      </Col>
    </Row>
    <Row>
      <Col md={6}>
        <FormGroup>
          <FormControl
            componentClass="select"
            onChange={props.onAutoredemptionChange}
            value={props.autoredemptionValue}
          >
            <option value="">
              [Autoredemption]
            </option>
            <option value="true">
              YES
            </option>
            <option value="false">
              NO
            </option>
          </FormControl>
        </FormGroup>
      </Col>
      <Col className="actions" md={6}>
        <Button
          className="red-ghost-btn"
          onClick={props.onSearch}
        >
          Apply
        </Button>

        <Button
          className="grey-ghost-btn"
          onClick={props.onClear}
        >
          Clear search/filters
        </Button>
      </Col>
    </Row>
  </Panel>
);

export default RedemptionSearch;



// WEBPACK FOOTER //
// ./src/components/admin/staff-reward/redemptions/redemption-search.jsx